import React, { Component } from 'react';

import Infinite from 'react-infinite';
import { EduItem, Loading } from 'components';
import { injectIntl, defineMessages } from 'react-intl';
import { Image } from 'semantic-ui-react';

import styles from './Edu.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class EduList extends Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const filterUpdateCheck = this.props.filterUpdate;
    if (filterUpdateCheck) {
      return filterUpdateCheck;
    } else {
      return filterUpdateCheck;
    }
  }

  // 태그 선택시 대상자 rerender 처리
  componentDidUpdate(prevProps, prevState) {
    // 대상자 Height 설정
    // 데이터가 없으면 rf.scrollable이 아예 생성 안됨
    const rf = this.refScroll;
    if (!!rf && !!rf.scrollable) {
      const { heightData, numberOfChildren } = rf.state.infiniteComputer;
      const isScroll = heightData * numberOfChildren > rf.scrollable.parentElement.clientHeight;

      // 높이가 달라진 경우
      // 스크롤이 생성 여부
      if (
        rf.computedProps.containerHeight !== rf.scrollable.parentElement.clientHeight ||
        isScroll !== this.state.eduScrollData['isScroll']
      ) {
        this.setState({
          eduScrollData: { isScroll: isScroll, height: rf.scrollable.parentElement.clientHeight }
        });
      }
    }

    const { needReload, selectedTag, targetParam } = this.props;
    if (
      // 대상자 새로고침
      (needReload && !this.state.isLoading) ||
      // 선택한 태그가 변경되었을 때
      selectedTag !== prevProps.selectedTag ||
      // parameter가 변경되었을때
      targetParam !== prevProps.targetParam
    ) {
      this.onGetEduTarget(true);

      // 새로고침시 스크롤 맨위로 이동
      if (!!rf && !!rf.scrollable) {
        rf.scrollable.scrollTop = 0;
        // rf.infiniteHandleScroll(0);
        // rf.handleScroll(0);
      }
    }
  }

  render() {
    const { formatMessage } = this.props.intl;
    const {
      eduTargetOrdering,
      tagDataByTagNo,
      eduTargetDataByTargetNo,
      eduSummaryByEduNo,
      selectEduNo,
      handleSelectDeclare,
      eduScrollData,
      onRefScroll,
      page,
      totalPages,
      onGetEduTarget,
      isLoading,
      handleSelectEduTarget
    } = this.props;

    let eduContentInfo = false;

    if (selectEduNo !== 'all') {
      eduContentInfo = eduSummaryByEduNo.get(String(selectEduNo));
      eduContentInfo = eduContentInfo.get('fileInfo');
    }

    const targetComponent = eduTargetOrdering.map(
      // 컴포넌트로 매핑
      (targetNo, i) =>
        !!eduTargetDataByTargetNo.get(String(targetNo)) && (
          <EduItem
            key={i}
            selectEduNo={selectEduNo}
            target={eduTargetDataByTargetNo.get(String(targetNo))}
            eduContentInfo={eduContentInfo}
            tagDataByTagNo={tagDataByTagNo}
            handleSelectDeclare={handleSelectDeclare}
            handleSelectEduTarget={handleSelectEduTarget}
            eduSummaryByEduNo={eduSummaryByEduNo}
          />
        )
    );
    return (
      <div className={cx('target-content')}>
        <div className={cx('target-content-inner')}>
          {targetComponent.size > 0 ? (
            <Infinite
              className={cx({ noScroll: !eduScrollData['isScroll'] })}
              ref={Infinite => {
                onRefScroll(Infinite);
              }}
              containerHeight={eduScrollData['height']}
              elementHeight={36}
              infiniteLoadBeginEdgeOffset={200}
              timeScrollStateLastsForAfterUserScrolls={1000}
              onInfiniteLoad={page !== totalPages ? onGetEduTarget : () => {}}
              loadingSpinnerDelegate={
                isLoading && (
                  <div className={cx('targetLoading')}>
                    <Loading content={'Loading...'} />
                  </div>
                )
              }
              isInfiniteLoading={isLoading}>
              {targetComponent}
            </Infinite>
          ) : (
            <div className={cx('noScroll', 'noTarget')}>
              <div className={cx('noScroll-icon-area')}>
                <Image src="/img/exam/list_noTarget.png" />
              </div>
              <div className={cx('')}>
                <div className={cx('noScroll-title')}>
                  {defineMessages(formatMessage({ id: 'Edu_54', defaultMessage: '교육 대상자가 없습니다' }))}
                </div>
                <div className={cx('noScroll-subTitle')}>
                  {defineMessages(formatMessage({ id: 'Edu_55', defaultMessage: '교육을 실시하세요' }))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default injectIntl(EduList);



// WEBPACK FOOTER //
// ./src/script/components/edu/EduList.js